/* Publish by EComposer at 2025-08-01 19:29:08*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-q4wwq67558c"]=  window.__ectimmers["ecom-q4wwq67558c"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(t&&t.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",t.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-q4wwq67558c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q4wwq67558c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y851xcqchq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y851xcqchq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lrkfsrpxwg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lrkfsrpxwg9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fgwf599xmx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fgwf599xmx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-54beyg06qsv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-54beyg06qsv', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-d9e16ioxqgu"]=  window.__ectimmers["ecom-d9e16ioxqgu"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(i){if(!e)return;const o=e.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-d9e16ioxqgu"]["xkoynbrfl"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var t=e.querySelector(".ecom__element--button");this.isLive&&t&&t.dataset.ecTrackingId&&t.addEventListener("click",function(i){if(window.Shopify.analytics){i.preventDefault();let o=document.createElement("div");document.body.appendChild(o),o.click();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const s=Object.assign({button_id:t.id,tracking_id:t.dataset.ecTrackingId},n);Shopify.analytics.publish("ec_custom_events",s),t.cloneNode(!0).click()}},{once:!0}),this.isLive&&t&&t.dataset.eventTrackingFb&&t.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${t.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-d9e16ioxqgu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d9e16ioxqgu', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kqoznkbtpb"]=  window.__ectimmers["ecom-kqoznkbtpb"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let t=this.$el;if(!t)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=t.querySelector(".ecom-element.ecom-base-image"),s=t.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-kqoznkbtpb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kqoznkbtpb', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f17lard2tns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f17lard2tns', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}